
import { 
    EDIT_USER,
    EDIT_USER_SUCCESS,
    EDIT_USER_FAIL, 
    EDIT_USER_RESET,
} from "../actions/editUserAction";

const initialState = {
    apiState: "",
    message: "",
    data: null,
    error: "",
}

const editUserReducer = (state = initialState, action) => {
    switch (action.type) {
        case EDIT_USER:
            return {
                ...state,
                apiState: "loading",
            };
        case EDIT_USER_SUCCESS:
            return {
                ...state,
                apiState: "success",
                data: action.response.data,
                message: action.response.message ? action.response.message : "success",
            };
        case EDIT_USER_FAIL:
            return {
                ...state,
                apiState: "error",
                error: action.response.errors,
                message: action.response.message ? action.response.message : "error",
            };
        case EDIT_USER_RESET:
            return initialState;
        default: 
            return state;
    }
};

export default editUserReducer;
